module.exports = __webpack_public_path__ + "img/chickensigara.c289ccbd.gif";